import { defineMessages } from 'react-intl';

export const messages: {
	openInNewTabLabel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	goalDirectoryNavLabel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	projectDirectoryNavLabel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	createNewGoalButtonLabel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	followingNavLabel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	statusUpdatesNavLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	archivedNavLabel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
} = defineMessages({
	openInNewTabLabel: {
		id: 'townsquare.goals-app.side-nav.open-in-new-tab',
		description:
			'Label on an external link icon for links to 0]00][0products in the side nav which will open the link in a new tab',
		defaultMessage: 'Open in new tab',
	},
	goalDirectoryNavLabel: {
		id: 'townsquare.goals.side-nav.goals-directory',
		description: 'Side nav button to open goals directory page',
		defaultMessage: 'Goal directory',
	},
	projectDirectoryNavLabel: {
		id: 'townsquare.goals.side-nav.project-directory',
		description: 'Side nav button to open project directory page',
		defaultMessage: 'Project directory',
	},
	createNewGoalButtonLabel: {
		id: 'townsquare.goals.side-nav.create-goal-button',
		description: 'Label for create new goal button',
		defaultMessage: 'Create new goal',
	},
	followingNavLabel: {
		id: 'townsquare.goals.side-nav.following-goals',
		description: 'Side nav button to open following goals page',
		defaultMessage: 'Following',
	},
	statusUpdatesNavLabel: {
		id: 'townsquare.atlassian-home.side-nav.status-updates',
		defaultMessage: 'Status updates',
		description: 'Side nav button to open projects updates page',
	},
	archivedNavLabel: {
		id: 'townsquare.goals.side-nav.archived-goals',
		description: 'Side nav button to open archived goals page',
		defaultMessage: 'Archived',
	},
});
